import { useDeviceType } from "@/common/hooks";
import { useGetTrendingTags } from "@/common/queries/queries";
import { deviceTypeEnum } from "@/common/utils/device";
import { useMemo } from "react";
import { ITag } from "@/common/services/types";

const MAX_DESKTOP_ITEMS = 5;
const MAX_MOBILE_ITEMS = 3;

export const useTrendingTags = () => {
  const { data, isLoading } = useGetTrendingTags();
  const deviceType = useDeviceType();
  const isPhone = useMemo(() => deviceType === deviceTypeEnum.PHONE, [deviceType]);

  const adaptedTrendingTags = useMemo(() => {
    const trendingTags = data?.map((item: ITag) => ({ type: "tag", text: item.name, gifs: item.count })) || [];
    return trendingTags.slice(0, isPhone ? MAX_MOBILE_ITEMS : MAX_DESKTOP_ITEMS);
  }, [data, isPhone]);

  return {
    trendingTags: adaptedTrendingTags,
    isLoading
  };
};
